import { Box, Typography, styled } from '@mui/material';

export const FeatureBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  paddingBottom: theme.spacing(1),
}));

export const FeatureText = styled(Typography)(() => ({
  fontSize: 12,
}));

export const ArticleImage = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  my: theme.spacing(3),
  py: theme.spacing(3),
}));

export const Ring = styled('div')(({ theme }) => ({
  width: theme.spacing(27.25),
  minWidth: theme.spacing(13),
  height: theme.spacing(27.25),
  minHeight: theme.spacing(13),
  border: '2px solid white',
  borderRadius: '50%',
}));

export const ImagesWrapper = styled('div')(({ theme }) => ({
  width: theme.spacing(42),
  minWidth: theme.spacing(13),
  height: theme.spacing(31.75),
  minHeight: theme.spacing(13),
  aspectRatio: '1/1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',

  '& img': {
    position: 'absolute',
  },

  '& .image-top': {
    width: theme.spacing(24),
    right: 0,
    top: 0,
  },

  '& .image-bottom': {
    width: theme.spacing(23),
    left: 0,
    bottom: 0,
  },
}));
